import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {CommonModule} from '@angular/common';

/**
 * Full palette of pill / badge variants across the Design 2.0 redesign. New
 * usages should add to this enum rather than defining bespoke classes per
 * call-site.
 *
 *  - `blue` / `green` / `gray` / `orange` / `red` / `pink` / `lime` —
 *    vehicle-list row status pills (originals, keep stable).
 *  - `vneseno` — olive-green pill used for "Vneseno" / "IZDANO" / count
 *    badges on the Nabava/Prodaja detail cards.
 *  - `info` / `warn` / `muted` — generic info/warning/dim neutral pills
 *    used inline in cards, tables, KPI areas.
 *  - `kpiYellow` / `kpiBlue` / `kpiPurple` / `kpiGreen` / `kpiRed` — soft
 *    KPI pills for the right-rail Info card (days in stock, oglasa,
 *    status, marža). `kpiRed` is the loss / negative-margin counterpart
 *    to `kpiGreen`.
 */
export type V2StatusPillVariant =
  | 'blue' | 'green' | 'gray' | 'orange' | 'red' | 'pink' | 'lime'
  | 'vneseno'
  | 'info' | 'warn' | 'muted'
  | 'kpiYellow' | 'kpiBlue' | 'kpiPurple' | 'kpiGreen' | 'kpiRed';

/**
 * Design 2.0 status pill primitive — fully-rounded label badge. Projected
 * content is the label.
 */
@Component({
  selector: 'app-v2-status-pill',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './v2-status-pill.component.html',
  styleUrls: ['./v2-status-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class V2StatusPillComponent {
  readonly variant = input<V2StatusPillVariant>('gray');

  readonly pillClasses = computed(() => {
    return `v2-pill v2-pill--${this.variant()}`;
  });
}
